(function () {
  if (!document.body.classList.contains('template-product')) return;

  var RESET_MS = 3000;
  var resetTimers = new WeakMap();
  var lastAtcButton = null;

  function lockAfterAction() {
    /* Keep theme from requesting heavy mini_cart sections on ATC. */
    if (window.T4Sconfigs) window.T4Sconfigs.afterActionATC = '0';
  }

  lockAfterAction();
  document.addEventListener('DOMContentLoaded', lockAfterAction);
  window.addEventListener('load', lockAfterAction);

  function getAllAtcButtons() {
    return document.querySelectorAll('[data-atc-form], [data-action-atc]');
  }

  function getLabel(btn) {
    return btn && btn.querySelector('.t4s-btn-atc_text');
  }

  function defaultLabelText(label) {
    return (
      (label && label.dataset.rbAtcDefault) ||
      (window.T4SProductStrings && window.T4SProductStrings.addToCart) ||
      'Add to cart'
    );
  }

  function showAdded() {
    getAllAtcButtons().forEach(function (btn) {
      var label = getLabel(btn);
      if (!label) return;

      label.dataset.rbAtcDefault = label.dataset.rbAtcDefault || label.textContent.trim();
      label.textContent = 'Added!';

      clearTimeout(resetTimers.get(btn));
      resetTimers.set(
        btn,
        setTimeout(function () {
          label.textContent = defaultLabelText(label);
        }, RESET_MS)
      );
    });
  }

  function setLoading(btn, isLoading) {
    var buttons = btn ? [btn] : getAllAtcButtons();

    buttons.forEach(function (target) {
      target.classList.toggle('is--loading', isLoading);
      if (isLoading) {
        target.setAttribute('aria-disabled', 'true');
      } else {
        target.removeAttribute('aria-disabled');
      }

      target.querySelectorAll('.t4s-loading__spinner, .t4s-svg-spinner').forEach(function (el) {
        if (isLoading) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });
    });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
    document.body.classList.toggle('t4s-cart-count-0', count === 0);
  }

  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  /* Safari reports JSON.parse failures as "The string did not meet its expected pattern." */
  function parseCartJson(response) {
    return response.text().then(function (text) {
      var data = null;
      if (text && text.trim()) {
        try {
          data = JSON.parse(text);
        } catch (err) {
          throw new Error('Could not add to cart');
        }
      } else {
        data = {};
      }

      if (!response.ok || (data && data.status && Number(data.status) >= 400)) {
        throw new Error(
          (data && (data.description || data.message)) || 'Could not add to cart'
        );
      }

      return data;
    });
  }

  /* Empty selling_plan (ReCharge one-time) can 422 with a pattern validation error. */
  function buildCartFormData(form) {
    var source = new FormData(form);
    var clean = new FormData();

    source.forEach(function (value, key) {
      if (key === 'selling_plan') {
        var plan = String(value == null ? '' : value).trim();
        if (!plan || !/^\d+$/.test(plan)) return;
        clean.append(key, plan);
        return;
      }
      clean.append(key, value);
    });

    return clean;
  }

  function readSellingPlanId() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    var input = form.querySelector('[name="selling_plan"]');
    if (!input || input.disabled) return null;
    var plan = String(input.value || '').trim();
    return /^\d+$/.test(plan) ? plan : null;
  }

  function cartAdd(form) {
    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      },
      body: buildCartFormData(form)
    }).then(parseCartJson);
  }

  function cartAddVariant(variantId, quantity) {
    var id = String(variantId || '').trim();
    if (!/^\d+$/.test(id)) {
      return Promise.reject(new Error('Could not add to cart'));
    }

    var item = { id: id, quantity: quantity || 1 };
    var sellingPlan = readSellingPlanId();
    if (sellingPlan) item.selling_plan = Number(sellingPlan);

    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: [item] })
    }).then(parseCartJson);
  }

  function refreshCartCount() {
    return fetch(cartRoot() + 'cart.js', {
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      return response.text().then(function (text) {
        try {
          return text ? JSON.parse(text) : {};
        } catch (err) {
          return {};
        }
      });
    });
  }

  /* Side cart HTML refresh — off the critical path so "Added!" is not blocked. */
  function refreshMiniCartBackground() {
    try {
      if (window.T4SThemeSP && window.T4SThemeSP.Cart && typeof window.T4SThemeSP.Cart.getToFetch === 'function') {
        window.T4SThemeSP.Cart.getToFetch();
      }
    } catch (err) {
      /* ignore */
    }
  }

  function handleAddError(err) {
    var message = (err && err.message) || 'Could not add to cart';
    if (/expected pattern|unexpected token|is not valid json|failed to fetch|networkerror/i.test(message)) {
      message = 'Could not add to cart';
    }
    if (window.T4SThemeSP && window.T4SThemeSP.Notices) {
      window.T4SThemeSP.Notices(message);
    }
  }

  function runAdd(btn, addPromise) {
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    if (btn.dataset.rbAtcBusy === '1') return;

    btn.dataset.rbAtcBusy = '1';
    setLoading(btn, true);

    addPromise
      .then(function () {
        showAdded();
        setLoading(btn, false);
        btn.dataset.rbAtcBusy = '0';

        refreshCartCount()
          .then(function (cart) {
            if (cart && typeof cart.item_count === 'number') updateCartCount(cart.item_count);
          })
          .catch(function () {});

        refreshMiniCartBackground();
      })
      .catch(function (err) {
        handleAddError(err);
        setLoading(btn, false);
        btn.dataset.rbAtcBusy = '0';
      });
  }

  /* Capture-phase intercept so theme ProductAjax never waits on mini_cart sections. */
  document.addEventListener(
    'click',
    function (event) {
      var stickyBtn = event.target.closest('[data-action-atc]');
      var formBtn = event.target.closest('[data-atc-form]');
      var btn = stickyBtn || formBtn;
      if (!btn) return;

      var label = getLabel(btn);
      if (label) label.dataset.rbAtcDefault = label.textContent.trim();
      lastAtcButton = btn;

      if (stickyBtn) {
        event.preventDefault();
        event.stopImmediatePropagation();

        var variantId = stickyBtn.getAttribute('data-variant-id');
        if (!variantId) return;

        var scope = stickyBtn.closest('[data-sticky-addtocart]') || document;
        var qtyInput = scope.querySelector('[data-quantity-value]');
        var qty = qtyInput
          ? parseInt(qtyInput.value, 10) || 1
          : parseInt(stickyBtn.getAttribute('data-qty'), 10) || 1;

        runAdd(stickyBtn, cartAddVariant(variantId, qty));
        return;
      }

      if (formBtn) {
        var form = formBtn.closest('form[action*="/cart/add"]');
        if (!form) return;
        if (formBtn.disabled || formBtn.getAttribute('aria-disabled') === 'true') return;

        event.preventDefault();
        event.stopImmediatePropagation();
        runAdd(formBtn, cartAdd(form));
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches('form[action*="/cart/add"]')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var btn = form.querySelector('[data-atc-form]') || lastAtcButton;
      runAdd(btn, cartAdd(form));
    },
    true
  );
})();
